import React from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'

interface BannerProps {
    apiValues: any;
}



const Aboutsection: React.FC<BannerProps> = ({ apiValues }) => {

    const stats = [
        {
            icon: "count-one.svg",
            text: "$74,160: average annual salary for agricultural scientists",
            iconBg: "bg-[#FFF0EE]",
            iconColor: "text-[#E81D2A]",
        },
        {
            icon: "count-two.svg",
            text: "Projected job openings for agricultural workers every year this decade",
            iconBg: "bg-[#ECEDFE]",
            iconColor: "text-[#21B477]",
        },
        {
            icon: "count-three.svg",
            text: "9% projected job growth of agricultural scientists in job market by 2030",
            iconBg: "bg-[#FFF4E5]",
            iconColor: "text-[#FFB500]",
        },
        {
            icon: "count-four.svg",
            text: "Projected job openings for ground maintenance workers every year this decade",
            iconBg: "bg-[#ECEBFB]",
            iconColor: "text-[#392C7D]",
        },
    ];
    const route = all_routes;
    return (
        <>
            {/* About Section */}


            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-5">

                {
                    (Array.isArray(apiValues?.cards) ? apiValues?.cards : []).map((item: any, index: number) => {

                        return (

                            <div
                                key={index}
                                className="flex items-center bg-white p-4 rounded-xl shadow-sm"
                            >
                                <div
                                    // className={`w-12 h-12 flex items-center justify-center rounded-full ${item.iconBg} mr-4`}
                                    className={`w-12 h-12 flex items-center justify-center rounded-full mr-4`}
                                >
                                    <ImageWithBasePath
                                        source={item.imageUrl}
                                        alt="icon"
                                        className="w-8 h-8"
                                    />
                                </div>
                                <p className="text-sm text-gray-700">{item.title}</p>
                            </div>
                        )
                    }) || []
                }
            </div>



        </>

    )
}

export default Aboutsection
